import { render, staticRenderFns } from "./PreRecDefaultLayout.vue?vue&type=template&id=0ca54a98&scoped=true&"
import script from "./PreRecDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PreRecDefaultLayout.vue?vue&type=script&lang=js&"
import style0 from "./PreRecDefaultLayout.vue?vue&type=style&index=0&id=0ca54a98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca54a98",
  null
  
)

export default component.exports